import React from 'react';
import { Link } from 'react-router-dom';

const Contact = () => (
  <div className="about">
    <Link to="/" className="about__close">
      <i className="icon icon--close"></i>
    </Link>

    <div className="about__intro">
      <div className="about__intro-title">Contact</div>
    </div>

    <div className="about__row">
      <h2 className="about__row-title">Galleries</h2>
      <div className="about__row-item">
        <p>
          <a href="mailto:mail@galerieburster.com">mail@galerieburster.com</a>
        </p>
        <p>
          <a href="mailto:leipzig@reitergalleries.com">leipzig@reitergalleries.com</a>
        </p>
        <p>
          <a href="mailto:info@olssongallery.com">info@olssongallery.com</a>
        </p>
        <p>
          <a href="mailto:ferenbalmgurbruestation@gmail.com">ferenbalmgurbruestation@gmail.com</a>
        </p>
        <p>
          <a href="mailto:info@eliridgway.com">info@eliridgway.com</a>
        </p>
      </div>

      <div className="about__row">
        <h2 className="about__row-title">Personal</h2>
        <div className="about__row-item">
          <p>
            <a href="mailto:ganter.contact@googlemail.com">ganter.contact@googlemail.com</a>
          </p>
          <br/>
          <p>
            <a href="https://www.instagram.com/wolfgang_ganter/" target="_blank" rel="noopener noreferrer" style={{fontSize: 24}}>
              <i className="icon icon--instagram" />
            </a>
          </p>
        </div>
      </div>

    </div>
  </div>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/views/contact/index.js